let defaultPlanning = {
    title: '',
    description: '',
    starts_at: '',
    ends_at: '',
    report_deadline_at: '',
    is_required: true,
    status: 'scheduled',
    responsible_user_id: null,
    participant_ids: [],
    participants: [],
    questions: [
        {text: 'Яка бажана тема наступної планерки?'},
        {text: 'Що корисного ви взяли з поточної планерки?'},
        {text: ''},
    ],
};

export default defaultPlanning;
